// Constants
export const DIRECTION_CONFIG = {
  HORIZONTAL: {
    LTR: "LTR",
    RTL: "RTL",
  },
  VERTICAL: {
    BTT: "BTT",
    TTB: "TTB",
  },
};

export const EDITOR_MODES = {
  BUILDER: "builder",
  INPUT: "input",
  EXISTING: "existing",
};